import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import "moment/locale/id";
import OlinLogo from "../../../assets/icons/olinlogo.png";
import { verifyFakturPbf, verifyFakturPbfPdfUrl } from "../../../services/purchaseApi";

const DetailRow = ({ label, value }) => (
  <p className="text-[14px] text-[#333333] mb-4">
    {label}: {value}
  </p>
);

const InvoiceVerification = () => {
  moment.locale("id");

  const { invoiceUid } = useParams();
  const [faktur, setFaktur] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [showPdf, setShowPdf] = useState(false);

  useEffect(() => {
    const fetchFaktur = async () => {
      try {
        const res = await verifyFakturPbf(invoiceUid);
        setFaktur(res);
      } catch (err) {
        // Backend menjawab 404 baik untuk dokumen yang tidak dikenal maupun
        // untuk faktur yang dibatalkan; bedanya ada di error_code.
        setErrorMessage(
          err?.detail?.error_code === "INVOICE_STATUS_INVALID"
            ? "Dokumen ini tidak berlaku."
            : "Dokumen ini tidak ditemukan. Faktur ini tidak diterbitkan oleh Aplikasi OLIN Purchase.",
        );
      } finally {
        setLoading(false);
      }
    };

    fetchFaktur();
  }, [invoiceUid]);

  const handleOpenPdf = () => {
    // Di layar kecil PDF dibuka di tab baru; viewer bawaan browser HP tidak
    // bisa dipakai di dalam iframe sesempit itu.
    if (window.matchMedia("(max-width: 768px)").matches) {
      window.open(verifyFakturPbfPdfUrl(invoiceUid), "_blank", "noopener");
      return;
    }
    setShowPdf(true);
  };

  return (
    <div className="bg-[#1044C9] min-h-screen w-full flex justify-center py-8 px-4">
      <div className="bg-white w-full max-w-[600px] rounded-[4px] px-6 py-10 sm:px-12">
        <div className="flex flex-col items-center mb-10">
          <img src={OlinLogo} alt="OLIN" className="h-[52px] mb-2" />
          <p className="text-[18px] font-bold text-[#333333]">Purchase</p>
        </div>

        {loading ? (
          <p className="text-[14px] text-[#333333]">Memuat dokumen...</p>
        ) : errorMessage ? (
          <>
            <h1 className="text-[24px] font-bold text-[#333333] mb-8">
              Halaman Verifikasi Dokumen
            </h1>
            <p className="text-[16px] text-[#333333]">{errorMessage}</p>
          </>
        ) : (
          <>
            <h1 className="text-[24px] font-bold text-[#333333] mb-8">
              Halaman Verifikasi Dokumen
            </h1>
            <p className="text-[16px] text-[#333333] mb-8">
              Dokumen ini adalah Faktur Asli yang diterbitkan oleh Aplikasi OLIN
              Purchase, dengan detail:
            </p>

            <DetailRow label="Nomor Faktur" value={faktur.invoice_no} />
            <DetailRow
              label="Tanggal Faktur"
              value={moment(faktur.invoice_date).format("D MMMM YYYY")}
            />
            <DetailRow label="Nomor PO" value={faktur.po_number || "-"} />
            <DetailRow label="Nama Customer" value={faktur.company_name} />
            <DetailRow
              label="Faktur Ditandatangani oleh"
              value={faktur.apj_name}
            />
            <DetailRow label="Jabatan" value={faktur.apj_position} />
            <DetailRow label="Nomor SIPA" value={faktur.apj_sipa} />
            {faktur.signed_at ? (
              <DetailRow
                label="Ditandatangani pada"
                value={`${moment(faktur.signed_at).format(
                  "dddd, D MMMM YYYY HH:mm",
                )} WIB`}
              />
            ) : null}
            <DetailRow label="Status Faktur" value={faktur.status_label} />

            <div className="flex justify-center mt-10">
              <button
                onClick={handleOpenPdf}
                className="bg-[#1044C9] text-white text-[14px] font-bold rounded-full px-12 py-4"
              >
                Lihat Dokumen Digital
              </button>
            </div>

            {/* Iframe baru dipasang setelah tombol diklik: tiap pembukaan PDF
                memicu render dokumen di server. */}
            {showPdf ? (
              <iframe
                src={verifyFakturPbfPdfUrl(invoiceUid)}
                title="Dokumen Faktur"
                className="w-full h-[600px] mt-8 border border-[#C7C7C7]"
              />
            ) : null}
          </>
        )}

        <p className="text-[12px] italic text-[#333333] mt-12">
          *Created by OLIN Purchase
        </p>
      </div>
    </div>
  );
};

export default InvoiceVerification;
